import { LoanPaymentTypeEnum, LoanQuoteTerminationTypeEnum, LoanSecurityTypeEnum } from '@talos/kyoko';

export function loanProductDetailsForCompare(details: object | undefined): Record<string, unknown> {
  if (!details) {
    return {};
  }
  const detailsWithLoanDefaults = details as Record<string, unknown> & {
    TermType?: string;
    LoanPaymentType?: string;
    LoanSecurityType?: string;
  };
  const normalizedDetails: Record<string, unknown> = {
    ...details,
    TermType: detailsWithLoanDefaults.TermType ?? LoanQuoteTerminationTypeEnum.Fixed,
    LoanPaymentType: detailsWithLoanDefaults.LoanPaymentType ?? LoanPaymentTypeEnum.Periodic,
    LoanSecurityType: detailsWithLoanDefaults.LoanSecurityType ?? LoanSecurityTypeEnum.Secured,
  };

  if (normalizedDetails.LoanSecurityType === LoanSecurityTypeEnum.Unsecured) {
    const { CollateralAsset: _legacyCollateralAsset, ...detailsWithoutLegacyCollateral } = normalizedDetails;
    return detailsWithoutLegacyCollateral;
  }

  return normalizedDetails;
}
